<div class="cs-footer-container">
    <div class="footer-cta text-center">
        <div class="footer-cta-header">Let's create what's next.</div>
        <div class="footer-cta-buttons">
            <button class="footer-cta-button-1" (click)="redirectTo()">Contact Us</button>
        </div>
    </div>

    <div class="container-xxl footer-main">
        <div class="row">
            <!-- Logo -->
            <div class="col-md-2 col-12 cs-footer-logo-container">
                <div class="cs-footer-logo">
                    <img loading="lazy" src="https://img.culturestudio.app/label-generator-files/Chrome_small-1772660858344.png" alt="Culture Studio Company Logo" width="102" height="100" />
                </div>
            </div>

            <!-- Nav Column 1 -->
            <div class="col-md-1 col-4">
                <ul class="list-group list-group-light">
                    <a href="/catalog" class="list-group-item border-0">Catalog</a>
                    <a href="https://culturestudio.net/services" class="list-group-item border-0">Services</a>
                    <a href="https://culturestudio.net/technology/" class="list-group-item border-0">Technology</a>
                </ul>
            </div>

            <!-- Nav Column 2 -->
            <div class="col-md-2 col-4">
                <ul class="list-group list-group-light">
                    <a href="https://culturestudio.net/blog/" class="list-group-item border-0">Resources</a>
                    <a href="https://culturestudio.net/private-label/" class="list-group-item border-0">Private Label</a>
                    <a href="https://culturestudio.net/careers/" class="list-group-item border-0">Careers</a>
                </ul>
            </div>

            <!-- Nav Column 3 -->
            <div class="col-md-2 col-4">
                <ul class="list-group list-group-light">
                    <a href="https://culturestudio.net/about/" class="list-group-item border-0">About</a>
                    <a href="https://culturestudio.net/artwork-guidelines/" class="list-group-item border-0">Artwork Guidelines</a>
                    <a href="https://culturestudio.net/social-responsibility/" class="list-group-item border-0 text-nowrap">Social Responsibility</a>
                </ul>
            </div>

            <!-- Newsletter Signup -->
            <div class="col-md-5 col-12 newsletter-section">
                <div class="subscribe-header">Sign up for the Trend Report.</div>
                <div class="subscribe-buttons">
                    <input type="email" class="subscribe-input" placeholder="Enter your email address" aria-label="Email address for newsletter signup" />
                    <button class="subscribe-submit">Subscribe</button>
                </div>
                <p class="subscribe-subtext">Get weekly trends and product drops straight to your inbox.</p>
            </div>
        </div>

        <hr class="hr" />

        <div class="row cs-footer-bottom align-items-center">
            <div class="col-md-8 col-12 cs-copyright">
                <span>&copy; Chii Clothing Company, {{ getCurrentYear }}</span>
                <a href="https://culturestudio.net/privacy-policy/">Privacy Policy</a>
                <a href="https://culturestudio.net/terms-conditions/">Terms &amp; Conditions</a>
                <a href="https://culturestudio.net/accessibility/">Accessibility</a>
                <a href="https://culturestudio.net/sitemap/">Sitemap</a>
                <a href="https://culturestudio.net/documentation/">Documentation</a>
            </div>
            <div class="col-md-4 col-12 cs-footer-social-icons">
                <ul>
                    <li>
                        <a href="https://www.facebook.com/CultureStudioDecoratedMerchandise" target="_blank" aria-label="Facebook">
                            <i class="fab fa-facebook" aria-hidden="true"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/culturestudio/" target="_blank" aria-label="Instagram">
                            <i class="fab fa-instagram" aria-hidden="true"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/culture-studio" target="_blank" aria-label="LinkedIn">
                            <i class="fab fa-linkedin" aria-hidden="true"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/@culturestudio" target="_blank" aria-label="YouTube">
                            <i class="fab fa-youtube" aria-hidden="true"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
